// Self-only SRM transport state; never a human-directory or WATI-health feed.
export function bindSrmPresence(socket, userId, update) {
  let active = true;
  let generation = 0;
  const receive = (payload, expected = generation) => {
    if (!active || !socket.connected || expected !== generation || payload?.success !== true
      || payload.data?.source !== "srm" || String(payload.data.user_id) !== String(userId)
      || typeof payload.data.is_online !== "boolean") return;
    update(payload.data);
  };
  const reconcile = () => {
    const request = ++generation;
    update(null);
    socket.emit("srm:presence:get", response => receive(response, request));
  };
  const unavailable = () => { generation++; update(null); };
  const handler = payload => receive(payload);
  socket.on("srm:presence", handler);
  socket.on("connect", reconcile);
  socket.on("disconnect", unavailable);
  socket.on("connect_error", unavailable);
  if (socket.connected) reconcile();
  return { reconcile, dispose: () => {
    active = false; generation++;
    socket.off("srm:presence", handler);
    socket.off("connect", reconcile);
    socket.off("disconnect", unavailable);
    socket.off("connect_error", unavailable);
  } };
}
